"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordScreenBase = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../../components");
var ErrorManager_1 = __importDefault(require("../../components/Error/ErrorManager"));
var SuccessScreen_1 = require("../SuccessScreen");
/**
 * Component that renders a ResetPassword screen that allows a user to reset their password and shows a success message upon a successful password reset..
 *
 * @param PasswordProps props that will be passed to the SetPassword component
 * @param showSuccessScreen boolean that determines whether to show the success screen or not
 * @param slots used for ResetPasswordScreen SuccessScreen props
 * @param slotProps props that will be passed to the SuccessScreen component
 * @param errorDisplayConfig configuration for customizing how errors are displayed
 * @param SuccessScreen component that will be rendered when showSuccessScreen is true
 * @param WorkflowCardBaseProps props that will be passed to the WorkflowCard component
 * @param WorkflowCardHeaderProps props that will be passed to the WorkflowCardHeader component
 * @param WorkflowCardInstructionProps props that will be passed to the WorkflowCardInstructions component
 * @param WorkflowCardActionsProps props that will be passed to the WorkflowCardActions component
 * @returns a React JSX Element that renders a ResetPassword screen
 *
 * @category Component
 *
 */
var ResetPasswordScreenBase = function (props) {
    var cardBaseProps = props.WorkflowCardBaseProps || {};
    var headerProps = props.WorkflowCardHeaderProps || {};
    var instructionsProps = props.WorkflowCardInstructionProps || {};
    var actionsProps = props.WorkflowCardActionsProps || {};
    var passwordProps = props.PasswordProps || { onPasswordChange: function () { return ({}); } };
    var showSuccessScreen = props.showSuccessScreen, slots = props.slots, _a = props.slotProps, slotProps = _a === void 0 ? {} : _a, errorDisplayConfig = props.errorDisplayConfig;
    var getSuccessScreen = function (_props, SuccessScreen) { return (SuccessScreen ? SuccessScreen(_props || {}) : react_1.default.createElement(SuccessScreen_1.SuccessScreenBase, __assign({}, _props))); };
    return (react_1.default.createElement(react_1.default.Fragment, null, showSuccessScreen ? (getSuccessScreen(slotProps === null || slotProps === void 0 ? void 0 : slotProps.SuccessScreen, slots === null || slots === void 0 ? void 0 : slots.SuccessScreen)) : (react_1.default.createElement(components_1.WorkflowCard, __assign({}, cardBaseProps),
        react_1.default.createElement(components_1.WorkflowCardHeader, __assign({}, headerProps)),
        react_1.default.createElement(components_1.WorkflowCardInstructions, __assign({}, instructionsProps, { divider: true })),
        react_1.default.createElement(components_1.WorkflowCardBody, null,
            react_1.default.createElement(ErrorManager_1.default, __assign({}, errorDisplayConfig),
                react_1.default.createElement(components_1.SetPassword, __assign({}, passwordProps)))),
        react_1.default.createElement(components_1.WorkflowCardActions, __assign({}, actionsProps, { divider: true }))))));
};
exports.ResetPasswordScreenBase = ResetPasswordScreenBase;
